import logoVue from "@/assets/images/icons/svg/logo-vue.svg";

export const iconMap = {
	"logoVue": logoVue.id,
};
